import { createAction } from '@ngrx/store';

export const loginSuccessAction = createAction('[Auth] Login Success');
export const loginErrorAction = createAction('[Auth] Login Error', (error: Error) => ({
  error,
}));

export const logoutSuccessAction = createAction('[Auth] Logout Success');
